import { Theme } from '@mui/material';
import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 64px;
`;

interface BackgroundButtonProps {
  $complete?: boolean | 'none';
}

const getBackground = (
  theme: Theme, $complete?: boolean | 'none') => {
  if ($complete === true) return theme.palette.success.light;
  if ($complete === false) return theme.palette.error.light;
  if ($complete === 'none') return 'none';
  return theme.palette.backdrop.dark;
};

export const ButtonBackground = styled.div<BackgroundButtonProps>`
  background-color: ${({ theme, $complete }) => getBackground(theme, $complete)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
